<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useAuthStore } from './stores/auth'

const auth = useAuthStore()

onMounted(() => {
  // Resolve current session once on boot. Routes that require auth
  // wait for this via the router guard.
  void auth.bootstrap()
})
</script>

<template>
  <RouterView v-slot="{ Component, route }">
    <transition name="page" mode="out-in">
      <component :is="Component" :key="route.fullPath" />
    </transition>
  </RouterView>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity var(--mts-duration-base) var(--mts-ease-standard);
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
